/**
 * This method will return the hostname depending upon the current server mode.
 * @param {ServerMode : localhost, beta, alpha, live} serveMode 
 */

import config from './Config.json';
const chinaId = "8";

export function siteHost(serveMode) {
    if (localStorage.orderCountryId === chinaId) {
        return config.ApplicationUrlConfigs[localStorage.mode + '-china'];
    }
    return config.ApplicationUrlConfigs[localStorage.mode];
    /*
    var _hostName = "";
    if (serveMode === 'local') {
        _hostName = "http://localhost:55547/";
    }
    else if (serveMode === 'alpha') {
        _hostName = 'https://umalpha.powerweaveonline.com/';
    }
    else if (serveMode === 'beta') {
        _hostName = 'https://umbetav2.powerweaveonline.com/';
    }
    else if (serveMode === 'live') {
        _hostName = 'https://www.unimart.co/';
    }
    else if (serveMode === 'china') {
        _hostName = 'https://umchinareact.ewizsaas.com/'
    }
    return _hostName;*/
}

/**
 * This method will return the elastic server url depending upon the current server mode.
 * @param {ServerMode : localhost, beta, alpha, live} serveMode 
 */
export function elasticServerUrl(serveMode) {
    if (localStorage.userRole === 'marketinguser' && localStorage.orderCountryId === chinaId) {
        return config.ElasticServerUrlConfigs[localStorage.mode + '-china'];
    }
    else if (localStorage.IsESAuthenticate === "1") {
        return config.ElasticServerUrlConfigs[localStorage.mode + '-auth'];
    }
    return config.ElasticServerUrlConfigs[localStorage.mode];
    /*
    var _hostName = "";
    if (serveMode === 'local') {
        _hostName = 'http://localhost:9200';
    }
    else if (serveMode === 'alpha') {
        _hostName
            = 'https://search-alpha-um-lexjt5d7ctt2iivmnh4zsaiegm.eu-west-2.es.amazonaws.com/';
    }
    else if (serveMode === 'beta') {
        _hostName
            = 'https://search-beta-um-pd63ppgo47gqiwduio3epnvzaa.eu-west-2.es.amazonaws.com/';
    }
    else if (serveMode === 'live') {
        _hostName
            = 'https://search-live-um-oerqd2rvhhy4lryiuoe35p5qgq.eu-west-2.es.amazonaws.com/';
    }
    else if (serveMode === 'china') {
        _hostName
            = 'https://umchinaes.ewizsaas.com/';
    }

    return _hostName;*/
}


/**
 * This method will return the elastic server url depending upon the current server mode.
 * @param {serverUrl : complete URL of current window} serveMode 
 */
export function getHostType(serverUrl) {
    return localStorage.mode;
    /*
    var _hostName = "";
    if (serverUrl.includes('localhost:')) {
        _hostName = "local";
    }
    else if (serverUrl.includes('umreactbeta.')) {
        _hostName = "beta";
    }
    else if (serverUrl.includes('umreactalpha.')) {
        _hostName = "alpha";
    }
    else if (serverUrl.includes('umreact.')) {
        _hostName = "live";
    }
    else if (serverUrl.includes('umchina.')) {
        _hostName = "china";
    }
    return _hostName;*/
}


export function getServiceUrl(serveMode) {
    if (localStorage.userRole === 'marketinguser' && localStorage.orderCountryId === chinaId) {
        return config.NodeServiceUrlConfigs[localStorage.mode + '-china'];
    }
    return config.NodeServiceUrlConfigs[localStorage.mode + (serveMode ? '-' + serveMode : '')];
    /*
    var _hostName = "";
    if (serveMode === 'local') {
        _hostName = 'http://localhost:7000/api/';
    }
    else if (serveMode === 'alpha') {
        _hostName
            = 'https://umreactalpha.powerweaveonline.com:7443/api/';
    }
    else if (serveMode === 'beta') {
        _hostName
            = 'https://umreactbeta.powerweaveonline.com:8443/api/';
    }
    else if (serveMode === 'live') {
        _hostName
            = 'https://umreact.powerweaveonline.com/api/';
    }
    else if (serveMode === 'china') {
        _hostName
            = 'https://umchinareact.ewizsaas.com/api/';
    }
    return _hostName;*/
}


export function getServiceUrleTender(serveMode) {
    return config.NodeServiceUrlConfigs[localStorage.mode + "-etender"];
}

export function getCaptchaKey() {
    const captchaSiteKey = '6LfA7xEqAAAAAFqwmZyyl9aT42TpSrW80Kynr3TZ'
    return captchaSiteKey;
}

export function getAuthKey() {
    //var AuthKey =  'DZwDN3pShPM1iJMD';
    //Sha256 format
    var AuthKey = '095784175D7ECD6FA9B7D9415183B6DA9BBA80680C5F8751B8A8E329B8AC05D9'
    return AuthKey;
}
